export const EDIT_SUCCESS = 'Владелец ЭЗС обновлен';
export const EDIT_ERROR = 'Не удалось обновить владельца ЭЗС';
